// Reads embed-related URL params once at module load. The embed.js wrapper
// passes config to the iframe via these query params (and via postMessage for
// runtime updates — see App.js).

function parseEmbedConfig() {
  if (typeof window === "undefined") {
    return {
      embed: false,
      themeName: null,
      presetMode: null,
      agentDisplayName: null,
    };
  }
  let params;
  try {
    params = new URLSearchParams(window.location.search);
  } catch (_) {
    return {
      embed: false,
      themeName: null,
      presetMode: null,
      agentDisplayName: null,
    };
  }

  const truthy = (v) => v === "true" || v === "1";
  const mode = params.get("mode");
  const presetMode = mode === "voice" || mode === "text" ? mode : null;

  return {
    embed: truthy(params.get("embed")),
    themeName: params.get("theme") || null,
    presetMode,
    agentDisplayName: params.get("agent-name") || null,
  };
}

export const EMBED_CONFIG = parseEmbedConfig();
